module.exports = __webpack_public_path__ + "static/img/img3.efb243d.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img3.png
// module id = sFzP
// module chunks = 1